import view from '../../view';
import actionTypes from '../constants/action-types';
import historyStack from '../history/history-stack';
import getFocusedElementInfo from '../helpers/get-focused-element-info';
import setSelectionByNodePath from '../helpers/set-selection-by-node-path';

const historyManager = (store) => (next) => (action) => {
  const { type } = action;

  if (type === view.actionTypes.SYNCHRONIZE_ELEMENT) {
    historyStack.clearRedoStack();
    historyStack.clearUndoStack();
  }

  if (type === actionTypes.REDO && !historyStack.isRedoEmpty()) {
    const currentState = getFocusedElementInfo();

    if (!currentState) {
      next(action);
      return;
    }

    historyStack.pushUndoAction(currentState);

    const nextState = historyStack.popRedoAction();

    const { selectionData, innerHTML, id } = nextState;
    const liveElement = view.accessors.getLiveElement(id);

    liveElement.innerHTML = innerHTML;

    const selection = setSelectionByNodePath(liveElement, selectionData);

    store.dispatch(view.actions.setSelection(selection));
  }

  if (type === actionTypes.UNDO && !historyStack.isUndoEmpty()) {
    const currentState = getFocusedElementInfo();

    if (!currentState) {
      next(action);
      return;
    }

    historyStack.pushRedoAction(currentState);

    let prevState = historyStack.popUndoAction();

    const { innerHTML, id } = prevState;
    const liveElement = view.accessors.getLiveElement(id);

    if (liveElement.innerHTML === innerHTML) {
      prevState = historyStack.popUndoAction() || prevState;
    }

    liveElement.innerHTML = prevState.innerHTML;
    const selection = setSelectionByNodePath(liveElement, prevState.selectionData);
    store.dispatch(view.actions.setSelection(selection));
  }

  next(action);
};

export default historyManager;
